export default "__VITE_ASSET__Ce8j7_Iu__"